__turbopack_context__.v({
  "label": "jEGCYG_label",
  "list": "jEGCYG_list",
  "removeButton": "jEGCYG_removeButton",
  "root": "jEGCYG_root",
  "searchItem": "jEGCYG_searchItem",
  "searchItemText": "jEGCYG_searchItemText",
});
